module.exports = __webpack_public_path__ + "img/10.2c6369b.png";